import { GetterTree, MutationTree, Module } from 'vuex';
import { ApiState, RootState } from '@/store/types';

const state: ApiState = {
  ipPro: 'https://www.pronunciator.com',
  ipLearn: 'https://learning.pronunciator.com',
};

const getters: GetterTree<ApiState, RootState> = {
  ipPro(apiState, apiGetters, rootState): string {
    return rootState.debugMode ? 'https://www.pronunciator.com' : apiState.ipPro;
  },
  ipLearn(apiState, apiGetters, rootState): string {
    return rootState.debugMode ? 'https://learning.pronunciator.com' : apiState.ipLearn;
  },
  URL_TRANSLATIONS(apiState, apiGetters): string {
    return `${apiGetters.ipPro}/menus/pro/`;
  },
  URL_TRANSLATIONS_DEFAULT(apiState, apiGetters): string {
    return `${apiGetters.ipPro}/menus/pro/297.xml`;
  },
  URL_LANGUAGES_BLUEBIRD(apiState, apiGetters): string {
    return `${apiGetters.ipPro}/menus/pro/bb.xml`;
  },
  URL_LANGUAGES_ISPEAK(apiState, apiGetters): string {
    return `${apiGetters.ipLearn}/i-speak-pro-secure.php`;
  },
  URL_LANGUAGES_ILEARN(apiState, apiGetters): string {
    return `${apiGetters.ipLearn}/i-learn-pro-secure.php`;
  },
  URL_SKILLS(apiState, apiGetters): string {
    return `${apiGetters.ipPro}/menus/pro/skills.xml`;
  },
  URL_VIDEO_LANGUAGES(apiState, apiGetters): string {
    return `${apiGetters.ipPro}/menus/pro/video-languages.xml`;
  },
  URL_FLAGS(apiState, apiGetters): string {
    return `${apiGetters.ipLearn}/files/images/bb/flags/`;
  },
  URL_LEVELS_ALLOWED(apiState, apiGetters): string {
    return `${apiGetters.ipPro}/menus/pro/levels_ready.xml`;
  },
  URL_POSTCARDS_IMAGES(apiState, apiGetters): string {
    return `${apiGetters.ipLearn}/files/postcards/postcards.xml`;
  },
  URL_PERSONALIZED_COURSES(apiState, apiGetters): string {
    return `${apiGetters.ipLearn}/course/designer/bluebird.php`;
  },
  URL_PERSONALIZED_COURSES_PDF(apiState, apiGetters): string {
    return `${apiGetters.ipLearn}/phrasebook_personalized_bb.php`;
  },
  URL_LEVELS(apiState, apiGetters): string {
    return `${apiGetters.ipLearn}/levels-pro-secure.php`;
  },
  URL_TOPICS(apiState, apiGetters): string {
    return `${apiGetters.ipPro}/menus/pro/topics.xml`;
  },
  URL_OCCUPATIONS(apiState, apiGetters): string {
    return `${apiGetters.ipPro}/menus/pro/occupations.xml`;
  },
  URL_AGES_RANGES(apiState, apiGetters): string {
    return `${apiGetters.ipPro}/menus/pro/ages.xml`;
  },
  URL_LEVELS_PERSONALIZED(apiState, apiGetters): string {
    return `${apiGetters.ipLearn}/levels-custom-secure.php`;
  },
  URL_DAILY_COURSES(apiState, apiGetters): string {
    return `${apiGetters.ipLearn}/course/designer/daily_lesson.php`;
  },
  URL_UNITS(apiState, apiGetters): string {
    return `${apiGetters.ipLearn}/units-pro-secure.php`;
  },
  URL_UNITS_PERSONALIZED(apiState, apiGetters): string {
    return `${apiGetters.ipLearn}/units-custom-secure.php`;
  },
  URL_PHRASES(apiState, apiGetters): string {
    return `${apiGetters.ipLearn}/getdata-pro-secure-08112018.php`;
  },
  URL_PHRASES_PERSONALIZED(apiState, apiGetters): string {
    return `${apiGetters.ipLearn}/getdata-custom-secure.php`;
  },
  URL_AUDIO(apiState, apiGetters): string {
    return `${apiGetters.ipLearn}/download-m4a-dyn-bb-firebase-noauth.php`;
  },
  URL_AUDIO_PERSONALIZED(apiState, apiGetters): string {
    return `${apiGetters.ipLearn}/course/designer/download-m4a-dyn-bb-firebase.php`;
  },
  URL_SUBTITLES(apiState, apiGetters): string {
    return `${apiGetters.ipLearn}/DWg9Dw3B.php`;
  },
  URL_COMPARE_AUDIO(apiState, apiGetters): string {
    return `${apiGetters.ipLearn}/getdata-pro-secure-08112018.php`;
  },
  URL_FLASHCARDS_REMOVE(apiState, apiGetters): string {
    return `${apiGetters.ipLearn}/flashcard-save-secure.php`;
  },
  URL_INSTITUTION_PIN_CHECK(apiState, apiGetters): string {
    return `${apiGetters.ipLearn}/chk-pin.php`;
  },
  URL_RAPID_TEST(apiState, apiGetters): string {
    return `${apiGetters.ipLearn}/bb/cat/`;
  },
};

const api: Module<ApiState, RootState> = {
  state,
  getters,
};

export default api;
